<template>
    <div class="copyright">
        <div class="container">Copyright © GuangDong TipDM Intelligent Technology Co.,Ltd. <span id="year">2023</span> &nbsp;&nbsp; 广东泰迪智能科技股份有限公司 &nbsp;&nbsp; <a href="http://beian.miit.gov.cn" target="_blank">粤ICP备14098620号</a> &nbsp;&nbsp; <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011202000980" target="_blank">粤公网安备 44011202000988号</a></div>
    </div>
</template>
<script>
    export default {

    }
</script>
